import Link from '../../views/Link2approverequestpage';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intl: ownProps.match.params.intl,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  reference_id: state.shift.assessment.reference_id,
  quotation_id: state.shift.assessment.quotation_id,
  po_num: state.shift.assessment.po_num,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  popwindow: state.shift.status.popwindow
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    // getQuotbypo: qoid => {                          
      
    //   dispatch(actions.getQuotbypo(qoid)).then(() =>
    //   dispatch(push(`/${locale}/translatedcoderequest`))
    //    );
    // }

getQuotbypo: qoid => {

  dispatch(actions.getQuotbypo(qoid));
 
},

gotopage: () => {
  
  dispatch(push(`/${locale}/translatedcoderequest`));
 
}


  };
};

const Link2approverequestpage = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Link2approverequestpage;



// WEBPACK FOOTER //
// ./src/components/container/Link2approverequestpage/index.js